import React from 'react';
import Spinner from '@atlassian/jira-common-components-spinner/src/view.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { Props } from './NotFoundProps.types.tsx';

const LazyNotFoundErrorPage = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "async-arj-not-found-page", jiraPriority: 'ondemand' */ './NotFoundErrorPage.tsx'
		),
);

export const AsyncNotFoundErrorPage = (props: Props): React.JSX.Element => (
	<Placeholder name="arj-not-found-page" fallback={<Spinner />}>
		<LazyNotFoundErrorPage {...props} />
	</Placeholder>
);
